export default {"src":"/_next/static/media/smartphone.c64d27d2.svg","height":68,"width":69};